import { TileLayout } from '@/shared/enums';
import DefaultLayout from './default.vue';
import EpisodeLayout from './episode.vue';
import LiveLayout from './live.vue';
import LogoLayout from './logo.vue';
import HeroSliderLayout from './hero-slider.vue';
import HeroMultipleLayout from './hero-multiple.vue';
import TrailerLayout from './trailer.vue';

export default {
  [TileLayout.DEFAULT]: DefaultLayout,
  [TileLayout.EPISODE]: EpisodeLayout,
  [TileLayout.LIVE]: LiveLayout,
  [TileLayout.LOGO]: LogoLayout,
  [TileLayout.HERO_SLIDER]: HeroSliderLayout,
  [TileLayout.HERO_MULTIPLE]: HeroMultipleLayout,
  [TileLayout.TRAILER]: TrailerLayout,
};
